// @flow
import $ from 'jquery';
import 'fg-frontend/plugins/required/jquery.cookies-policy';

/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */
export default (): void => {
	$('body').cookiesPolicy({
		lang: window.projectConfig.lang,
		css: {
			brandColor: '#1f9b46'
		},
		position: 'bottom',
		template: function(data) {
			return  '<div class="container__' + data.contId + ' clearfix">\n' +
					'   <div class="container"><div class="row">\n' +
					'		<div class="js_fallbackStyle1 col-sm-9 col-md-10">' + data.text +
					'</div><div class="js_fallbackStyle2 col-sm-3 col-md-2">\n'+
					'			<a class="js_acceptCookies js_buttonStyle" href="javascript:void(0)">' + data.accept + '</a>\n' +
					'		</div>\n' +
					'   </div></div>\n' +
					'</div>';
		},
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CookiesPolicy.js